var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.btnFlag)?_c('div',{staticClass:"back-to-top",on:{"click":_vm.totop}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[_c('div',{staticClass:"iconfont"},[_vm._v("")]),_vm._v(" "),_c('div',{staticClass:"backtopfont"},[_vm._v("顶部")])])
}]

export { render, staticRenderFns }